import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import get from 'lodash/get';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import { replacePropertyPlaceholders } from '../utils/replacePlaceholders';

const FundCardHeaderWrapper = styled<any, any>('div')`
    ${propStyles};
`;

FundCardHeaderWrapper.defaultProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingX: ["md", "lg"],
    paddingY: ["md", "lg"]
};

const FundCardHeading = styled<any, any>('h1')`
    ${propStyles};
`;

FundCardHeading.defaultProps = {
    color: "body",
    fontFamily: "body",
    fontWeight: "regular",
    fontSize: ["md", "lg"],
    margin: "0 1em 0 0"
};

const FundCardLink = styled<any, any>('a')`
    ${propStyles};
`;

FundCardLink.defaultProps = {
    flex: "0 0 auto",
    color: "white",
    bgColor: "primary",
    fontFamily: "heading",
    fontWeight: "bold",
    fontSize: ["xs", "sm"],
    textDecoration: "none",
    textAlign: "center",
    paddingX: "md",
    paddingY: "sm",
    borderRadius: "1em",
};

@observer
class FundCardHeader extends Component<any, any> {
    @computed
    get fundName() {
        const { nameProperty } = this.props.header;
        return get(this.props.shareClass, `properties_pub.${nameProperty}.value`);
    }

    @computed
    get fundLink() {
        const { linkProperty } = this.props.header;
        const linkValue = get(this.props.shareClass, `properties_pub.${linkProperty}.value`, '');
        const parsedLink = replacePropertyPlaceholders(this.props.shareClass.properties_pub, linkValue);
        return parsedLink;
    }

    @computed
    get fundLinkLabel() {
        const { linkLabel } = this.props.header;
        return linkLabel;
    }

    render() {
        const { fundName, fundLink, fundLinkLabel } = this;
        const { theme } = this.props;

        return (
            <FundCardHeaderWrapper
                {...theme.FundCardHeader}
            >
                <FundCardHeading
                    {...theme.FundCardHeading}
                >
                    {fundName}
                </FundCardHeading>
                {
                    fundLinkLabel && (
                        <FundCardLink
                            href={fundLink}
                            {...theme.FundCardLink}
                        >
                            <Translate>{fundLinkLabel}</Translate>
                        </FundCardLink>
                    )
                }
            </FundCardHeaderWrapper>
        );
    }
}

export default withTheme(FundCardHeader) as any;


// WEBPACK FOOTER //
// ./src/Components/FundCardHeader.tsx